import type { Product, ProductVariant } from '@/types';
import { cn } from '@/lib/cn';

export function VariantSelector({
  product,
  selected,
  onSelect,
}: {
  product: Product;
  selected: ProductVariant;
  onSelect: (v: ProductVariant) => void;
}) {
  if (product.variants.length <= 1) return null;
  return (
    <div>
      <span className="mb-2 block font-condensed text-xs font-bold uppercase tracking-wider text-night-blue/70">
        {product.variants[0].id.match(/mg$/) ? 'Strength' : product.variants[0].id.match(/oz$/) ? 'Size' : 'Option'}
      </span>
      <div className="flex flex-wrap gap-2">
        {product.variants.map(v => (
          <button
            key={v.id}
            type="button"
            disabled={!v.inStock}
            onClick={() => onSelect(v)}
            className={cn(
              'min-w-[64px] rounded-soft border-2 px-4 py-2 text-sm font-bold transition-colors',
              v.id === selected.id
                ? 'border-leaf-green bg-leaf-green/10 text-night-blue'
                : 'border-night-blue/15 text-night-blue/70 hover:border-leaf-green',
              !v.inStock && 'cursor-not-allowed opacity-40'
            )}
          >
            {v.label}
          </button>
        ))}
      </div>
    </div>
  );
}
